import { AutomationStatus } from '@dadohr/shared/domainTypes/experience';
import assertNever from 'assert-never';
import { useMemo } from 'react';
import { Color, ColoredChip } from '../../../../components/ColoredChip';
import { UnsafeTFunction, useUnsafeTranslation } from '../../../../i18next';

export const getAutomationStatusChipConfig = (
  // Accepts the synthetic 'RUNNING' the denormalizer rolls up while an
  // in-flight sync action is polling (mirrors the per-action display status).
  status: AutomationStatus | 'RUNNING',
  t: UnsafeTFunction
): [string, Color] => {
  switch (status) {
    case AutomationStatus.UPCOMING:
      return [t('Upcoming'), 'gray'];
    case AutomationStatus.TRIGGERED:
      return [t('Triggered'), 'gray'];
    case 'RUNNING':
      return [t('Running'), 'blue'];
    case AutomationStatus.DONE:
      return [t('Done'), 'green'];
    case AutomationStatus.ERROR:
      return [t('Error'), 'red'];
    case AutomationStatus.SKIPPED:
      return [t('Skipped'), 'darkGray'];
    default:
      return assertNever(status);
  }
};

export const AutomationStatusChip = ({
  status,
  variant,
  autoWidth,
  color = 'normal'
}: {
  status: AutomationStatus | 'RUNNING';
  variant?: 'rounded' | 'squared';
  autoWidth?: boolean;
  color?: 'light' | 'normal';
}) => {
  const { t } = useUnsafeTranslation();
  const [label, c] = useMemo(() => getAutomationStatusChipConfig(status, t), [status, t]);
  return (
    <ColoredChip
      color={c}
      size="small"
      width={autoWidth ? 'auto' : 104}
      variant={variant}
      mode={color}
    >
      {label}
    </ColoredChip>
  );
};
